import React from "react";
import Legends from "./Legends.jsx";

const SearchResults = ({ results, selectedPocketType, singleType, pageOptions, clickCount, onOptionClick }) => {
  const {DefaultSelectedAttributeId} = pageOptions;
  return (
    <div className="panel-body">
      {results.length > 0 ? (
        results.map((legend, index) => {
          return (
            <Legends
              singleType={singleType}
              pageOptions={pageOptions}
              legend={legend}
              index={index}
              key={legend[0].DisplayName} // Changed key so search results do not conflict with legend component with matching key based on index
              selectedPocketType={DefaultSelectedAttributeId}
              clickCount={clickCount}
              onOptionClick={onOptionClick}
            />
          );
        })
      ) : (
        ""
      )}
    </div>
  );
};

export default SearchResults;
